import { useEffect } from 'react';
import { PANEL_URL } from '../lib/api';

/**
 * turnivo.pl/verify-email?token=… → ten sam link w panelu (gdy użytkownik wejdzie na domenę landingowej).
 * Zachowuje query string (token).
 */
export default function RedirectToPanelVerifyEmail() {
  useEffect(() => {
    const qs = typeof window !== 'undefined' ? window.location.search || '' : '';
    window.location.href = `${PANEL_URL}/verify-email${qs}`;
  }, []);

  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-50">
      <p className="text-slate-600">Przekierowuję do potwierdzenia konta…</p>
    </div>
  );
}
